import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import routes, { navLinks } from "./config/routes.jsx";
import { rightControls } from "./config/rightControls.js";
import { DarkModeToggle } from "@cadenza/theme";
import { MessageBanner } from "@cadenza/messages";
import "@cadenza/messages/styles";

// components
import { Sidebar } from "@cadenza/ui";
import AppFooter from "./components/AppFooter.jsx";
import FreeModeBanner from "./free-mode-banner.jsx";

function App() {
  return (
    <div className="site-container">
      <Sidebar
        title="RAD Tool"
        links={navLinks}
        leadingControls={[{ key: "dark", Component: DarkModeToggle }]}
        trailingControls={rightControls}
        pinnedInitially={false}
      />

      <main className="sidebar-page-shell">
        <FreeModeBanner />
        <Suspense fallback={<div>Loading…</div>}>
          <Routes>
            {routes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Routes>
        </Suspense>
        <MessageBanner />
        <AppFooter />
      </main>
    </div>
  );
}

export default App;
